import type { ScopeNode } from "../../../../AppView/ScopeManagement/ScopeProvider/ScopeProvider";

export type ScopeNodeType = "scope" | "group";

export const NODE_TYPE_LABELS: Record<ScopeNodeType, string> = {
  scope: "Scope",
  group: "Group",
};

export interface ScopeRef {
  id: string;
  name: string;
  node_type: ScopeNodeType;
}

// A node of this kind with this name already sits where a write would put one.
export interface NameCollision {
  name: string;
  node_type: ScopeNodeType;
}

// What the review shell renders: a hard stop or a proceed-with-care.
export type ScopeGuardrailOutcome = "blocked" | "warning";

// The scope tree plus the node an action targets; the view renders the
// target's ancestors and its subtree, flagging the descendants in use.
export interface AffectedHierarchy {
  tree: ScopeNode | ScopeNode[];
  targetId: string;
  descendantsInUse: ScopeRef[];
  targetInUse?: boolean;
}
